import styled, { keyframes } from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const LEDGER_CONTAINER_BORDER_RADIUS = "14px";
const LOTTIE_EXPAND_WRAPPER_HEIGHT = "53px";
const LEDGER_SCROLLABLE_MAX_HEIGHT = "260px";

const expandDown = keyframes`
    from {
        grid-template-rows: 0fr;
        opacity: 0;
    }
    to {
        grid-template-rows: 1fr;
        opacity: 1;
    }
`;

export const LottieExpandWrapper = styled.div`
    display: grid;
    grid-template-rows: 0fr;
    min-height: ${LOTTIE_EXPAND_WRAPPER_HEIGHT};
    animation: ${expandDown} 0.5s ease-out forwards;

    & > * {
        overflow: hidden;
        min-height: 0;
    }
`;

export const SenderPopupContainer = styled.div(({ theme }) => ({
    borderRadius: theme.cornerRadius.medium,
    background: "linear-gradient(312deg, #000 -10.23%, #004C2F 84.95%)",
    padding: theme.spacing.xxxSmall,
    display: "flex",
    flexDirection: "column",
}));

export const SenderPopupHeaderContent = styled.div(({ theme }) => ({
    padding: `0 ${theme.spacing.xSmall}`,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing.xxSmall,
}));

export const MirroredIconWrapper = styled.div({
    transform: "scaleX(-1)",
});

export const SenderPopupText = styled(Text)(({ theme }) => ({
    textAlign: "center",
    padding: `${theme.spacing.medium} 0`,
}));

export const LedgerContainer = styled.div(() => ({
    borderRadius: LEDGER_CONTAINER_BORDER_RADIUS,
    overflow: "hidden",
}));

export const LedgerScrollable = styled.div({
    maxHeight: LEDGER_SCROLLABLE_MAX_HEIGHT,
    overflowY: "auto",
});
